import { render, staticRenderFns } from "./ShortTab.vue?vue&type=template&id=16c7026c&scoped=true"
import script from "./ShortTab.vue?vue&type=script&lang=js"
export * from "./ShortTab.vue?vue&type=script&lang=js"
import style0 from "./ShortTab.vue?vue&type=style&index=0&id=16c7026c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c7026c",
  null
  
)

export default component.exports